<template>
  <div class="work-detail">
    <div class="nav">
      <img
        src="https://portal-minio.pass.lygtc.edu.cn/cms/%E9%A1%B6%E9%83%A8%E5%AF%BC%E8%88%AA%E6%A0%8Flogo-1607933659282.png"
        alt=""
      />
      <span class="ml">|</span>
      <span>一周工作查询信息</span>
    </div>
    <div class="work-content">
      <div class="title">一周工作查询信息</div>
      <el-card class="box-card">
        <el-form :inline="true" :model="workInfo" class="demo-form-inline">
          <el-form-item label="工作时间：">
            <el-col :span="11">
              <el-date-picker
                type="date"
                placeholder="选择开始日期"
                v-model="workInfo.startDate"
                style="width: 100%"
                @change="getStartTime"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-date-picker
                type="date"
                placeholder="选择结束日期"
                v-model="workInfo.endDate"
                style="width: 100%"
                @change="getEndTime"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSearchBook(workInfo)"
              >查询</el-button
            >
            <el-button @click="onReset">重置</el-button>
          </el-form-item>
        </el-form>
        <!-- 动态根据内容区域高度给表格固定表头 -->
        <div class="el-table-style">
          <div class="el-table-user">
            <el-table
              :data="workData"
              border
              style="width: 100%; margin-top: 20px"
              height="calc(100vh - 320px)"
            >
              <el-table-column
                prop="rq"
                label="月日"
                sortable
                align="center"
              ></el-table-column>
              <el-table-column prop="xq" label="星期" width="80" align="center">
              </el-table-column>
              <!-- <el-table-column
                prop="zt"
                label="主题"
                align="center"
              ></el-table-column> -->
              <el-table-column
                prop="gznr"
                label="工作内容"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="cjry"
                label="参与人员"
                align="center"
                width="400"
              ></el-table-column>
              <el-table-column prop="sj" label="时间" align="center" width="80">
              </el-table-column>
              <el-table-column prop="dd" label="地点" align="center">
              </el-table-column>
              <el-table-column prop="zjz" label="召集" align="center">
              </el-table-column>
            </el-table>
          </div>
        </div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next"
          :total="totalSize"
        >
        </el-pagination>
      </el-card>
    </div>
  </div>
</template>

<script>
import {
  getWorkInfo,
  getDataWorkList,
  getPaganationWorkList,
} from '@/api/lianyungang.js';
export default {
  data() {
    return {
      // 当前页
      currentPage: 1,
      // 一页显示多少条
      pageSize: 80,
      // 总页数
      totalSize: 100,
      workInfo: {
        startDate: '',
        endDate: '',
      },
      spanArr: [], // 一个空的数组，用于存放每一行记录的合并数
      pos: 0, // spanArr 的索引
      contentSpanArr: [],
      position: 0,
      workData: [
        {
          rq: '2021-09-31',
          xq: '二',
          gznr: '全省高校实验室安全互查',
          cjry: '教务处相关人员',
          sj: '9:00',
          dd: '厚德楼304室',
          zjz: '葛仁福',
          id: '20210931',
        },
        {
          rq: '2021-09-30',
          xq: '一',
          gznr: '全省高校实验室安全互查',
          cjry: '教务处相关人员',
          sj: '9:00',
          dd: '厚德楼304室',
          zjz: '葛仁福',
          id: '20210930',
        },
        {
          rq: '2021-09-30',
          xq: '一',
          gznr: '全省高校实验室安全互查',
          cjry: '教务处相关人员',
          sj: '9:00',
          dd: '厚德楼304室',
          zjz: '葛仁福',
          id: '20210930',
        },
      ],
      nowMonday: '',
      nowSunday: '',
    };
  },
  created() {
    this.getWeek();
    this.fetchWorksList();
    // this.judgeRepeat(this.workData);
  },
  methods: {
    getFormatDate(date) {
      let month = date.getMonth() + 1;
      let strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = '0' + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate;
      }
      let currentDate = date.getFullYear() + '-' + month + '-' + strDate + ' ';
      return currentDate;
    },
    getWeek() {
      let now = new Date();
      let nowTime = now.getTime();
      let day = now.getDay();
      let oneDayTime = 24 * 60 * 60 * 1000;

      //显示周一
      let MondayTime = nowTime - (day - 1) * oneDayTime;
      //显示周日
      let SundayTime = nowTime + (7 - day) * oneDayTime;

      //初始化日期时间
      this.nowMonday = this.getFormatDate(new Date(MondayTime));
      this.nowSunday = this.getFormatDate(new Date(SundayTime));
    },
    // 将表单输入框的内容数据进行格式化
    getStartTime(date) {
      // this.workInfo.startDate = date;
    },
    getEndTime(date) {
      // this.workInfo.endDate = date;
    },
    // 重置
    onReset() {
      this.fetchWorksList();
    },
    // 根据日期查询
    onSearchBook(workInfo) {
      let data = {
        startDate: workInfo.startDate,
        endDate: workInfo.endDate,
      };
      getDataWorkList(data).then((res) => {
        this.workInfo = {};
        this.workData = res.data.data.list;
        this.workData.forEach((item) => {
          this.$set(item, 'xq', this.getweekday(item.rq));
        });
        this.totalSize = this.workData.length;
      });
    },
    // 根据日期判断是周几
    getweekday(date) {
      var weekArray = new Array('日', '一', '二', '三', '四', '五', '六');
      var week = weekArray[new Date(date).getDay()]; //注意此处必须是先new一个Date
      return week;
    },
    // 获取一周工作详情列表
    fetchWorksList() {
      let data = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        startDate: this.nowMonday,
        endDate: this.nowSunday,
      };
      getPaganationWorkList(data).then((res) => {
        if (res.code == 0) {
          this.workData = res.data.data.list;
          this.totalSize = res.data.data.total;
          this.workData.forEach((item) => {
            this.$set(item, 'xq', this.getweekday(item.rq));
          });
        }
      });

      // console.log(this.workData);
    },
    // 将拿到的数据进行判断是否重复
    judgeRepeat(arr) {
      // 设定一个数组spanArr/contentSpanArr来存放要合并的格数，同时还要设定一个变量pos/position来记录
      this.spanArr = [];
      this.contentSpanArr = [];
      let _this = this;
      for (var i = 0; i < arr.length; i++) {
        // 判断当前元素与上一个元素是否相同(第1和第2列)
        if (i === 0) {
          this.spanArr.push(1);
          this.pos = 0;
          this.contentSpanArr.push(1);
          this.position = 0;
        } else {
          if (arr[i].id === arr[i - 1].id) {
            _this.spanArr[this.pos] += 1;
            _this.spanArr.push(0);
          } else {
            _this.spanArr.push(1);
            _this.pos = i;
          }
          // 判断当前元素与上一个元素是否相同(第3列)
          if (arr[i].rq === arr[i - 1].rq) {
            _this.contentSpanArr[this.position] += 1;
            _this.contentSpanArr.push(0);
          } else {
            _this.contentSpanArr.push(1);
            _this.position = i;
          }
          if (arr[i].xq === arr[i - 1].xq) {
            _this.contentSpanArr[this.position] += 1;
            _this.contentSpanArr.push(0);
          } else {
            _this.contentSpanArr.push(1);
            _this.position = i;
          }
        }
      }
    },
    // 合并单元格
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // console.log(row, column);
      if (columnIndex === 0 || columnIndex === 1) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    handleSizeChange(val) {
      console.log(`当前页: ${val}`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchWorksList();
    },
  },
};
</script>

<style lang="scss" scoped>
.work-detail {
  .nav {
    display: flex;
    align-items: center;
    padding: 0 60px;
    height: 60px;
    width: 100%;
    height: 60px;
    background: rgb(57, 131, 218);
    color: #fff;
    .ml {
      margin-left: 4px;
      margin-right: 4px;
    }
    img {
      margin-top: 4px;
      vertical-align: middle;
    }
  }
  .work-content {
    margin: 0 60px;
    .title {
      margin: 20px 0;
      color: rgb(57, 131, 218);
    }
  }
  /deep/.el-form {
    display: flex;
    justify-content: flex-end;
  }
  /deep/.line {
    text-align: center;
  }
  /deep/.el-pagination {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
  }
  /deep/.el-table .cell {
    white-space: pre-line !important;
  }
  .el-table-style {
    width: 100%;
    // height: calc(100vh - 320px);
  }
  .el-table-user {
    max-height: 100%;
    overflow-y: auto;
  }
}
</style>